"use strict";

require("node_modules/angular-drag-and-drop-lists/angular-drag-and-drop-lists.min.js");

angular.module("dragScroll", []);

require("./drag-scroll.directive.js");



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/drag-scroll/drag-scroll.module.js
// module id = 677
// module chunks = 0